import { render } from "./ViewApiClients.vue?vue&type=template&id=8379b264&scoped=true"
import script from "./ViewApiClients.vue?vue&type=script&lang=js"
export * from "./ViewApiClients.vue?vue&type=script&lang=js"

import "./ViewApiClients.vue?vue&type=style&index=0&id=8379b264&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8379b264"]])

export default __exports__